/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/description.config.json";

export interface IDescriptionMethods extends IPluginMethodMap {
  getDescriptionProps(args: any): Promise<any>;
}

export class DescriptionService implements IAgentPlugin {
  readonly methods: IDescriptionMethods;

  constructor() {
    this.methods = {
      getDescriptionProps: this.getProps.bind(this),
    };
  }

  async getProps(args: any) {
    return { ...(config || {}) };
  }
}
